/* Uhu, az ajándékbagoly – beszélgetős ajándékkereső (Uhubox) */
(function () {
  'use strict';

  var NBSP = ' ';
  var BIG = 1e9;

  function fmtFt(n) {
    return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP) + NBSP + 'Ft';
  }
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('uhu_' + name, data || {});
    } catch (e) { /* nem kritikus */ }
  }

  /* ---------- Szótár ---------- */
  var RECIPIENTS = [
    { id: 'no', label: 'Nőnek', emoji: '👩', tag: 'nőknek', short: 'nőknek', say: 'Egy hölgynek',
      re: /\b(no|nonek|noknek|noi|anya\w*|anyu\w*|anyos\w*|feleseg\w*|baratno\w*|nover\w*|hugom\w*|hugomnak|nagymam\w*|mama\w*|mami\w*|nagyi\w*|keresztany\w*|kollegano\w*|tanarno\w*|tanito ?neni\w*|ovo ?neni\w*|nagyneni\w*|menyasszony\w*|holgy\w*|csaj\w*|sogorno\w*|lanyom\w*)\b/ },
    { id: 'ferfi', label: 'Férfinak', emoji: '👨', tag: 'férfiaknak', short: 'férfiaknak', say: 'Egy férfinak',
      re: /\b(ferfi\w*|apa|apa[mnkt]\w*|apu\w*|apos\w*|ferj\w*|volegeny\w*|batyam\w*|batyj\w*|ocsem\w*|ocse\w*|nagypap\w*|papa\w*|tata\w*|keresztapa\w*|fonok\w*|pasi\w*|pasim\w*|haver\w*|baratom\w*|baratnak|sogor\b|sogorom\w*|unokaocs\w*|nagybacsi\w*|fiam\w*|fiamnak|tanar\b|tanarnak|kollegam\w*|kollega\w*|uram\w*)\b/ },
    { id: 'gyerek', label: 'Gyereknek', emoji: '🧒', tag: 'gyerek', short: 'gyerekeknek', say: 'Egy gyereknek',
      re: /\b(gyerek\w*|gyermek\w*|kisfiu\w*|kislany\w*|unoka\b|unokam\w*|unokanak|baba\w*|ovis\w*|ovodas\w*|iskolas\w*|kiskamasz\w*|csemet\w*|kolyok\w*|elsos\w*|kicsik?nek|kicsiknek)\b/ }
  ];
  var PERSONAS = [
    { id: 'kreativ', label: 'Kreatív léleknek', emoji: '🎨', interest: 'kreativ', say: 'Egy kreatív léleknek' },
    { id: 'misztikus', label: 'Misztikus léleknek', emoji: '🔮', interest: 'misztikus', say: 'Egy misztikus léleknek' },
    { id: 'any', label: 'Még nem tudom', emoji: '🤷', say: 'Majd együtt kitaláljuk' }
  ];
  var OCCASIONS = [
    { id: 'karacsony', label: 'Karácsony', emoji: '🎄', tag: 'karacsony', say: 'karácsonyra',
      re: /\b(karacsony\w*|kari(ra|ba)?\b|xmas|fa ala|fenyo ala|unnep\w*|szenteste\w*)/ },
    { id: 'mikulas', label: 'Mikulás', emoji: '🎅', tag: 'mikulas', say: 'Mikulásra',
      re: /\b(mikulas\w*|telapo\w*|csizma\w*)/ },
    { id: 'szuletesnap', label: 'Születésnap', emoji: '🎂', tag: 'szuletesnap', say: 'születésnapra',
      re: /\b(szulinap\w*|szuletesnap\w*|szulnap\w*|birthday)/ },
    { id: 'nevnap', label: 'Névnap', emoji: '🌷', tag: 'nevnap', say: 'névnapra', re: /\b(nevnap\w*)/ },
    { id: 'csakugy', label: 'Csak úgy', emoji: '💝', tag: null, say: 'csak úgy, szeretetből',
      re: /\b(csak ugy|evfordulo\w*|valentin\w*|meglepet\w*|koszon\w*|ballag\w*|diploma\w*|nyugdij\w*|eskuvo\w*|bucsu\w*|gyogyul\w*)/ }
  ];
  var BUDGETS = [
    { id: 'b1', label: '5 000 Ft alatt', emoji: '🪙', min: 0, max: 5000 },
    { id: 'b2', label: '5–10 ezer', emoji: '💵', min: 5000, max: 10000 },
    { id: 'b3', label: '10–20 ezer', emoji: '💶', min: 10000, max: 20000 },
    { id: 'b4', label: '20 ezer felett', emoji: '✨', min: 20000, max: BIG },
    { id: 'b0', label: 'Mindegy', emoji: '🤷', min: 0, max: BIG }
  ];
  var INTERESTS = [
    { id: 'ekszer', label: 'Ékszer', emoji: '💍', ptag: 'ekszer',
      re: /(ekszer|fulbeval|nyaklanc|karkoto|medal|gyuru|bizsu)/, pre: /(fulbeval|nyaklanc|karkoto|medal|gyuru)/ },
    { id: 'wellness', label: 'Wellness & fürdő', emoji: '🛁', ptag: 'wellness',
      re: /(wellness|relax|pihen|masszaz|\bspa\b|furd|kenyeztet|stressz|szepseg|kozmetik|onapol)/, pre: /(furdobomba|furdoso|furdopezsgo|onapolo)/ },
    { id: 'illat', label: 'Gyertya & illat', emoji: '🕯️', ptag: 'illat',
      re: /(gyertya|illat|illoolaj|aroma|parfum|parologt)/, pre: /(gyertya|illoolaj|parologtato)/ },
    { id: 'tea', label: 'Tea & teázás', emoji: '🍵', ptag: 'tea',
      re: /(\btea|teaz|matcha|chai|kave)/, pre: /(teaskeszlet|teaskanna|matcha|chai)/ },
    { id: 'otthon', label: 'Otthon & dekor', emoji: '🏡', ptag: 'dekor',
      re: /(otthon|lakas|dekor|hangulat|lampa|vilagit|szokokut|kristaly)/, pre: /(lampa|szokokut|gyertyatarto|szelcsengo)/ },
    { id: 'kreativ', label: 'Kreatív & napló', emoji: '🎨', ptag: 'kreativ',
      re: /(kreativ|rajz|alkot|naplo|\biras|\bir\b|diy|foto|barkacs)/, pre: /(naplo|fotokeret)/ },
    { id: 'zene', label: 'Zene & hangfürdő', emoji: '🎶', ptag: 'zene',
      re: /(zene|dob\b|dobol|hangtal|hangfurdo|meditac|joga|hangszer|zenel)/, pre: /(happy drum|nyelvdob|hangtal|szelcsengo)/ },
    { id: 'misztikus', label: 'Misztikus & kristály', emoji: '🔮', ptag: 'misztikus',
      re: /(tarot|rune|runa|kristaly|asztrolog|horoszkop|csillagjegy|spiritual|misztik|jos)/, pre: /(tarot|runako|kristalycsoport)/ }
  ];
  var STOP = ('ajandek ajandekot ajandekra ajandeknak ajandekotlet szeretne szeret szeretnek szeretnem keresek keresunk kellene kene ' +
    'valami valamit olyan neki nekem nekunk ami aki ezer forint alatt felett folott szamara reszere egy meg is es vagy mert csak nagyon ' +
    'jo szep kis nagy uj tobb mint legyen lenne tudna lehet ilyen ahol max maximum legfeljebb kb korul kozott koruli valamint illetve ' +
    'eves evesnek ev ' + 'kinek mit milyen tudnal segits uhu kerlek koszi szia hello').split(' ');

  function byId(list, id) { for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i]; return null; }

  /* ---------- Szabad szöveg értelmezése ---------- */
  function parseBudget(t, out) {
    var re = /(\d{1,3}(?:[ .]\d{3})+|\d+)(?:,(\d+))?\s*(ezer|e\b|k\b|ft\b|forint|huf)?/g;
    var m, vals = [];
    while ((m = re.exec(t))) {
      var after = t.slice(re.lastIndex, re.lastIndex + 6);
      if (/^\s*(eves|ev\b|honap|db|darab|reszes|cm|ml)/.test(after) || /^\s*(eves|honapos)/.test(t.slice(m.index + m[1].length, m.index + m[1].length + 8))) continue;
      var v = parseFloat(m[1].replace(/[ .]/g, '') + (m[2] ? '.' + m[2] : ''));
      var unit = m[3] || '';
      if (!unit && v >= 1990 && v <= 2040) continue; // évszám
      if (unit === 'ezer' || unit === 'e' || unit === 'k') v *= 1000;
      else if (!unit && v < 1000 && /^\s*[-–]\s*\d+\s*(ezer|e\b|k\b)/.test(t.slice(re.lastIndex))) v *= 1000;
      if (v >= 300 && v <= 1000000) vals.push(v);
    }
    var below = /(alatt|\big\b|ezerig|forintig|ftig|max|legfeljebb|nem tobb|kevesebb|olcsobb|nem draga|ertekhatar)/.test(t);
    var above = /(felett|folott|tol\b|ezertol|legalabb|minimum|draga|tobb mint)/.test(t);
    if (vals.length >= 2) {
      out.min = Math.min(vals[0], vals[1]); out.max = Math.max(vals[0], vals[1]);
    } else if (vals.length === 1) {
      if (above && !below) { out.min = vals[0]; out.max = BIG; }
      else if (below) { out.min = 0; out.max = vals[0]; }
      else { out.min = 0; out.max = Math.round(vals[0] * 1.12); }
    }
    if (out.max == null) {
      if (/(olcso|apro|kis ajandek|kisebb|zsebpenz|jelkep|nem draga|nem tul draga)/.test(t)) { out.min = 0; out.max = 5000; }
      else if (/(premium|luxus|exkluziv|kulonleges|nagy ajandek|komoly|meno|draga)/.test(t)) { out.min = 18000; out.max = BIG; }
    }
  }

  function isKnown(w) {
    var s = ' ' + w + ' ', i;
    for (i = 0; i < RECIPIENTS.length; i++) if (RECIPIENTS[i].re.test(s)) return true;
    for (i = 0; i < OCCASIONS.length; i++) if (OCCASIONS[i].re.test(s)) return true;
    return false;
  }

  function parseText(raw, products) {
    var t = ' ' + norm(raw).replace(/[!?.;:()"'„”]/g, ' ').replace(/\s+/g, ' ') + ' ';
    var out = { recip: null, occ: null, min: null, max: null, interests: [], terms: [], teen: false, found: 0 };
    var age = t.match(/(\d{1,2})\s*(?:eves|ev)/);
    if (age) {
      var a = parseInt(age[1], 10);
      if (a <= 12) out.recip = 'gyerek';
      else if (a <= 17) out.teen = true;
    }
    if (!out.recip) {
      for (var i = 0; i < RECIPIENTS.length; i++) if (RECIPIENTS[i].re.test(t)) { out.recip = RECIPIENTS[i].id; break; }
      if (out.teen && out.recip === 'gyerek') out.recip = null;
    }
    for (var j = 0; j < OCCASIONS.length; j++) if (OCCASIONS[j].re.test(t)) { out.occ = OCCASIONS[j].id; break; }
    INTERESTS.forEach(function (it) { if (it.re.test(t)) out.interests.push(it.id); });
    parseBudget(t, out);
    // kulcsszavak, amelyek tényleg előfordulnak a termékcímekben
    t.split(' ').forEach(function (w) {
      if (w.length < 4 || /\d/.test(w) || STOP.indexOf(w) > -1 || isKnown(w)) return;
      var stems = [w.slice(0, 6), w.slice(0, 5)];
      if (w.length <= 5) stems.push(w.slice(0, 4));
      for (var s = 0; s < stems.length; s++) {
        var st = stems[s];
        if (st.length < 4) continue;
        var hit = false;
        for (var k = 0; k < products.length; k++) if (products[k].ntitle.indexOf(st) > -1) { hit = true; break; }
        if (hit) { if (out.terms.indexOf(st) < 0) out.terms.push(st); break; }
      }
    });
    out.found = (out.recip ? 1 : 0) + (out.occ ? 1 : 0) + (out.max != null ? 1 : 0) + out.interests.length + out.terms.length + (out.teen ? 1 : 0);
    return out;
  }

  /* ---------- Rangsorolás ---------- */
  function hasTag(p, tag) { return !!tag && p.tags.indexOf(tag) > -1; }
  function matchInterest(p, it) { return hasTag(p, it.ptag) || (it.pre && it.pre.test(p.ntitle)); }

  function scoreAll(products, st, relax) {
    var R = st.recip ? byId(RECIPIENTS, st.recip) : null;
    var O = st.occ ? byId(OCCASIONS, st.occ) : null;
    var min = st.min || 0, max = st.max == null ? BIG : st.max;
    var lo = relax ? min * 0.7 : min, hi = relax ? (max >= BIG ? BIG : max * 1.35) : max;
    var res = [];
    products.forEach(function (p, idx) {
      if (p.p < lo || p.p > hi) return;
      var s = 0, why = [];
      if (R) {
        if (hasTag(p, R.tag)) { s += 40; why.push(R.emoji + ' ' + R.short); }
        else if (relax < 2) return;
        else s -= 25;
      }
      if (st.teen) { if (hasTag(p, 'geek') || hasTag(p, 'techbox') || hasTag(p, 'logicbox')) s += 18; if (hasTag(p, 'gyerek') && !hasTag(p, 'geek')) s -= 6; }
      var anyInt = false;
      st.interests.forEach(function (id) {
        var it = byId(INTERESTS, id);
        if (it && matchInterest(p, it)) { s += 35; anyInt = true; if (why.length < 3) why.push(it.emoji + ' ' + it.label.toLowerCase()); }
      });
      if (st.interests.length && !anyInt) s -= 18;
      st.terms.forEach(function (term) { if (p.ntitle.indexOf(term) > -1) { s += 55; } });
      if (O) {
        if (O.tag && hasTag(p, O.tag)) { s += 12; if (why.length < 3) why.push(O.emoji + ' ' + O.say); }
        else if (O.tag) s -= 6;
        if (O.id === 'mikulas' && p.p <= 8000) s += 10;
      }
      if (max < BIG && max > 0) {
        var target = min + (Math.min(max, hi) - min) * 0.65;
        s += 8 * (1 - Math.min(1, Math.abs(p.p - target) / Math.max(1500, max - min)));
      }
      if (st.premium && hasTag(p, 'premium')) s += 8;
      s += ((idx * 7919 + st.round * 104729) % 97) / 97 * (st.round ? 14 : 3);
      res.push({ p: p, s: s, why: why });
    });
    res.sort(function (a, b) { return b.s - a.s; });
    return res;
  }

  function rankWithFallback(products, st) {
    var r = scoreAll(products, st, 0);
    var note = '';
    if (r.length < 3) {
      var r1 = scoreAll(products, st, 1);
      if (r1.length > r.length) { r = r1; note = 'A pontos keretben kevés volt, ezért hoztam pár hozzá közeli ötletet is.'; }
    }
    if (r.length < 3) {
      var r2 = scoreAll(products, st, 2);
      if (r2.length > r.length) { r = r2; note = 'Erre most kevés pontos találatom van, de ezek közel állnak hozzá.'; }
    }
    if (st.terms.length && r.length) {
      // ha konkrét szóra keresett, a találatok kerüljenek előre
      var withTerm = r.filter(function (x) { return st.terms.some(function (tm) { return x.p.ntitle.indexOf(tm) > -1; }); });
      if (!withTerm.length && !st.recip && !st.occ && st.max == null && !st.interests.length) note = 'Erre a szóra nincs pontos találatom, de ezek tetszhetnek:';
    }
    return { list: r, note: note };
  }

  /* ---------- Bagoly vezérlés ---------- */
  function Owl(root) {
    this.root = root;
    this.svg = root.querySelector('.uhu-owl');
    this.irises = Array.prototype.slice.call(root.querySelectorAll('[data-iris]'));
    this.eyes = [{ x: 78, y: 96 }, { x: 142, y: 96 }];
    this.reduce = reduceMotion();
    this.visible = false;
    this.lastMove = 0;
    this.pending = null;
    this.raf = 0;
    if (!this.svg) return;
    var self = this;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var v = en[0].isIntersecting;
        if (v && !self.greeted) { self.greeted = true; self.mood('is-wave', 1900); }
        self.visible = v;
      }, { threshold: 0.2 }).observe(this.svg);
    } else this.visible = true;
    var onMove = function (x, y) {
      self.lastMove = Date.now();
      if (!self.visible) return;
      self.pending = [x, y];
      if (!self.raf) self.raf = requestAnimationFrame(function () { self.raf = 0; if (self.pending) self.lookAt(self.pending[0], self.pending[1]); });
    };
    window.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse' || e.pointerType === 'pen') onMove(e.clientX, e.clientY); }, { passive: true });
    window.addEventListener('pointerdown', function (e) { onMove(e.clientX, e.clientY); }, { passive: true });
    this.blinkLoop();
    this.idleLoop();
  }
  Owl.prototype.lookAt = function (cx, cy) {
    var r = this.svg.getBoundingClientRect();
    if (!r.width) return;
    var s = r.width / 220;
    for (var i = 0; i < this.irises.length; i++) {
      var ex = r.left + this.eyes[i].x * s, ey = r.top + this.eyes[i].y * s;
      var dx = cx - ex, dy = cy - ey, d = Math.sqrt(dx * dx + dy * dy) || 1;
      var m = Math.min(8, d / (22 * s));
      this.irises[i].style.transform = 'translate(' + (dx / d * m).toFixed(2) + 'px,' + (dy / d * m).toFixed(2) + 'px)';
    }
  };
  Owl.prototype.lookAtEl = function (node) {
    if (!node || !this.svg) return;
    var r = node.getBoundingClientRect();
    this.lookAt(r.left + r.width / 2, r.top + Math.min(r.height / 2, 60));
    this.lastMove = Date.now();
  };
  Owl.prototype.mood = function (cls, ms) {
    var root = this.root;
    if (this.reduce && cls !== 'is-blink') return;
    root.classList.add(cls);
    clearTimeout(this['t_' + cls]);
    this['t_' + cls] = setTimeout(function () { root.classList.remove(cls); }, ms || 900);
  };
  Owl.prototype.blinkLoop = function () {
    var self = this;
    setTimeout(function () {
      if (self.visible && !document.hidden) {
        self.root.classList.add('is-blink');
        setTimeout(function () { self.root.classList.remove('is-blink'); }, 140);
        if (Math.random() < 0.25) setTimeout(function () {
          self.root.classList.add('is-blink');
          setTimeout(function () { self.root.classList.remove('is-blink'); }, 120);
        }, 300);
      }
      self.blinkLoop();
    }, 2400 + Math.random() * 3600);
  };
  Owl.prototype.idleLoop = function () {
    var self = this;
    setTimeout(function () {
      if (self.visible && !document.hidden && Date.now() - self.lastMove > 3500 && self.svg) {
        var r = self.svg.getBoundingClientRect();
        var ang = Math.random() * Math.PI * 2, dist = 80 + Math.random() * 200;
        if (Math.random() < 0.35) { ang = Math.PI / 2; dist = 300; }
        self.lookAt(r.left + r.width / 2 + Math.cos(ang) * dist, r.top + r.height * 0.4 + Math.sin(ang) * dist);
      }
      self.idleLoop();
    }, 2200 + Math.random() * 2200);
  };

  /* ---------- Kereső ---------- */
  function Finder(root) {
    this.root = root;
    this.mode = root.getAttribute('data-mode') || 'finder';
    this.say = root.querySelector('[data-uhu-say]');
    this.form = root.querySelector('[data-uhu-form]');
    this.input = this.form ? this.form.querySelector('input') : null;
    this.picked = root.querySelector('[data-uhu-picked]');
    this.qline = root.querySelector('[data-uhu-q]');
    this.chips = root.querySelector('[data-uhu-chips]');
    this.results = root.querySelector('[data-uhu-results]');
    this.owl = new Owl(root);
    this.initialSay = this.say ? this.say.textContent : '';
    this.products = this.loadProducts();
    this.reset(true);
    this.bind();
    if (this.mode === 'search') this.fromSearch();
    else { this.ask('recip', true); this.rotatePlaceholder(); }
  }

  Finder.prototype.loadProducts = function () {
    var node = this.root.querySelector('[data-uhu-products]');
    var list = [];
    try { list = JSON.parse(node ? node.textContent : '[]'); } catch (e) { list = []; }
    return list.filter(function (p) { return p && p.a && p.v; }).map(function (p) {
      var tags = (p.g || []).map(function (x) { return String(x).toLowerCase(); });
      return { t: p.t, u: p.u, p: p.p, cp: p.cp, i: p.i, v: p.v, tags: tags, ntitle: norm(p.t) };
    });
  };

  Finder.prototype.reset = function (silent) {
    this.st = { recip: null, occ: null, min: null, max: null, budgetId: null, interests: [], terms: [], teen: false, premium: false, round: 0, skip: {}, query: '' };
    this.shown = 0;
    if (!silent) {
      this.root.classList.remove('is-done');
      if (this.results) { this.results.hidden = true; this.results.innerHTML = ''; }
      if (this.input) this.input.value = '';
      this.ask('recip');
    }
  };

  Finder.prototype.bind = function () {
    var self = this;
    if (this.form) {
      this.form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = (self.input.value || '').trim();
        if (!v) { self.input.focus(); return; }
        self.free(v);
      });
      this.input.addEventListener('focus', function () { self.owl.lookAtEl(self.input); self.owl.mood('is-listen', 1600); });
      this.input.addEventListener('input', function () { self.owl.lookAtEl(self.input); self.root.classList.add('is-listen'); clearTimeout(self.tl); self.tl = setTimeout(function () { self.root.classList.remove('is-listen'); }, 900); });
    }
    this.root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]');
      if (!b || !self.root.contains(b)) return;
      var act = b.getAttribute('data-act'), val = b.getAttribute('data-val');
      if (act !== 'add') self.owl.lookAtEl(b);
      self.handle(act, val, b);
    });
  };

  Finder.prototype.talk = function (text, cb) {
    var self = this;
    if (!this.say) { if (cb) cb(); return; }
    if (reduceMotion()) { this.say.textContent = text; if (cb) cb(); return; }
    this.root.classList.add('is-think');
    this.say.classList.add('is-typing');
    this.say.textContent = '';
    clearTimeout(this.tt);
    this.tt = setTimeout(function () {
      self.root.classList.remove('is-think');
      self.say.classList.remove('is-typing');
      self.say.textContent = text;
      if (cb) cb();
    }, 420);
  };

  Finder.prototype.chip = function (label, emoji, act, val, extra) {
    var b = el('button', 'uhu-chip' + (extra ? ' ' + extra : ''));
    b.type = 'button';
    b.setAttribute('data-act', act);
    if (val != null) b.setAttribute('data-val', val);
    if (emoji) { var i = el('span', 'uhu-chip__e', emoji); i.setAttribute('aria-hidden', 'true'); b.appendChild(i); }
    b.appendChild(document.createTextNode(label));
    return b;
  };

  Finder.prototype.setChips = function (q, nodes) {
    if (this.qline) { this.qline.innerHTML = ''; if (q) { this.qline.appendChild(document.createTextNode(q)); this.qline.hidden = false; } else this.qline.hidden = true; }
    this.chips.innerHTML = '';
    var self = this;
    nodes.forEach(function (n) { self.chips.appendChild(n); });
  };

  Finder.prototype.renderPicked = function () {
    var st = this.st, out = [];
    var R = st.recip && byId(RECIPIENTS, st.recip);
    if (R) out.push(['recip', R.emoji + ' ' + R.label]);
    if (st.teen) out.push(['teen', '🧑 tininek']);
    var O = st.occ && byId(OCCASIONS, st.occ);
    if (O) out.push(['occ', O.emoji + ' ' + O.label]);
    if (st.max != null || st.min) {
      var B = st.budgetId && byId(BUDGETS, st.budgetId);
      var lbl = B ? B.emoji + ' ' + B.label : (st.max >= BIG ? '✨ ' + fmtFt(st.min) + ' felett' : (st.min ? '💶 ' + fmtFt(st.min) + ' – ' + fmtFt(st.max) : '💶 max ' + fmtFt(st.max)));
      if (!(B && B.id === 'b0')) out.push(['budget', lbl]);
    }
    st.interests.forEach(function (id) { var it = byId(INTERESTS, id); if (it) out.push(['int:' + id, it.emoji + ' ' + it.label]); });
    if (st.terms.length) out.push(['terms', '🔎 „' + st.query.slice(0, 28) + (st.query.length > 28 ? '…' : '') + '”']);
    this.picked.innerHTML = '';
    if (!out.length) { this.picked.hidden = true; return; }
    var self = this;
    out.forEach(function (x) {
      var b = el('button', 'uhu-pill');
      b.type = 'button';
      b.setAttribute('data-act', 'unpick');
      b.setAttribute('data-val', x[0]);
      b.setAttribute('aria-label', x[1] + ' – törlés');
      b.appendChild(document.createTextNode(x[1]));
      var xx = el('span', 'uhu-pill__x', '×'); xx.setAttribute('aria-hidden', 'true');
      b.appendChild(xx);
      self.picked.appendChild(b);
    });
    this.picked.hidden = false;
  };

  Finder.prototype.nextStep = function () {
    var st = this.st;
    if (!st.recip && !st.skip.recip && !st.interests.length && !st.teen) return 'recip';
    if (!st.occ && !st.skip.occ) return 'occ';
    if (st.max == null && !st.skip.budget) return 'budget';
    if (!st.interests.length && !st.skip.interest && !st.terms.length) return 'interest';
    return 'results';
  };

  Finder.prototype.ask = function (step, first) {
    var self = this, st = this.st, nodes = [];
    this.renderPicked();
    if (step === 'recip') {
      RECIPIENTS.forEach(function (r) { nodes.push(self.chip(r.label, r.emoji, 'recip', r.id)); });
      PERSONAS.forEach(function (p) { nodes.push(self.chip(p.label, p.emoji, 'persona', p.id)); });
      if (first) { this.setChips('Vagy kattints – kinek keresel ajándékot?', nodes); return; }
      this.talk('Kinek keresünk ajándékot?', function () { self.setChips('', nodes); });
      return;
    }
    if (step === 'occ') {
      OCCASIONS.forEach(function (o) { nodes.push(self.chip(o.label, o.emoji, 'occ', o.id)); });
      nodes.push(this.chip('Kihagyom', '', 'skip', 'occ', 'uhu-chip--ghost'));
      var who = st.recip ? byId(RECIPIENTS, st.recip).say : (st.interests.length === 1 && byId(PERSONAS, st.interests[0]) ? byId(PERSONAS, st.interests[0]).say : (st.teen ? 'Egy tininek' : 'Rendben'));
      this.talk(who + ', szuper! Milyen alkalomra?', function () { self.setChips('', nodes); });
      return;
    }
    if (step === 'budget') {
      BUDGETS.forEach(function (b) { nodes.push(self.chip(b.label, b.emoji, 'budget', b.id)); });
      var O = st.occ && byId(OCCASIONS, st.occ);
      this.talk((O ? (O.say.charAt(0).toUpperCase() + O.say.slice(1)) + ' – jó ötlet! ' : '') + 'Mennyit szánnál rá?', function () { self.setChips('', nodes); });
      return;
    }
    if (step === 'interest') {
      var base = scoreAll(this.products, { recip: st.recip, occ: null, min: st.min, max: st.max, interests: [], terms: [], teen: st.teen, round: 0 }, 0);
      var counts = INTERESTS.map(function (it) {
        var c = 0; base.forEach(function (x) { if (matchInterest(x.p, it)) c++; });
        return { it: it, c: c };
      }).filter(function (x) { return x.c > 0; }).sort(function (a, b) { return b.c - a.c; }).slice(0, 6);
      if (!counts.length) { st.skip.interest = true; this.showResults(); return; }
      counts.forEach(function (x) { nodes.push(self.chip(x.it.label, x.it.emoji, 'int', x.it.id)); });
      nodes.push(this.chip('Lepj meg, Uhu!', '🎲', 'skip', 'interest', 'uhu-chip--ghost'));
      this.talk('Utolsó kérdés: mi a szíve csücske?', function () { self.setChips('', nodes); });
      return;
    }
    this.showResults();
  };

  Finder.prototype.go = function () {
    if (this.results && !this.results.hidden) { this.showResults(); return; }
    this.ask(this.nextStep());
  };

  Finder.prototype.handle = function (act, val, btn) {
    var st = this.st;
    switch (act) {
      case 'recip': st.recip = val; st.skip.recip = true; track('answer', { q: 'recip', a: val }); this.go(); break;
      case 'persona':
        st.skip.recip = true;
        var P = byId(PERSONAS, val);
        if (P && P.interest) { st.interests = [P.interest]; }
        track('answer', { q: 'recip', a: val });
        this.go(); break;
      case 'occ': st.occ = val; track('answer', { q: 'occ', a: val }); this.go(); break;
      case 'budget':
        var B = byId(BUDGETS, val);
        st.budgetId = val; st.min = B.min; st.max = B.max; st.premium = B.id === 'b4';
        track('answer', { q: 'budget', a: val }); this.go(); break;
      case 'int': if (st.interests.indexOf(val) < 0) st.interests.push(val); track('answer', { q: 'interest', a: val }); this.go(); break;
      case 'skip': st.skip[val] = true; this.go(); break;
      case 'unpick':
        if (val === 'recip') { st.recip = null; st.skip.recip = false; }
        else if (val === 'teen') st.teen = false;
        else if (val === 'occ') { st.occ = null; st.skip.occ = false; }
        else if (val === 'budget') { st.min = null; st.max = null; st.budgetId = null; st.premium = false; st.skip.budget = false; }
        else if (val === 'terms') { st.terms = []; st.query = ''; }
        else if (val.indexOf('int:') === 0) { var id = val.slice(4); st.interests = st.interests.filter(function (x) { return x !== id; }); }
        this.go();
        break;
      case 'cheaper':
        var cur = this.current || [];
        var med = cur.length ? cur[Math.floor(cur.length / 2)].p.p : (st.max || 10000);
        st.min = 0; st.max = Math.max(2500, Math.min(st.max == null ? BIG : st.max, med) - 1); st.budgetId = null; st.premium = false;
        this.showResults('Rendben, kíméljük a pénztárcát:'); break;
      case 'fancier':
        var cur2 = this.current || [];
        var med2 = cur2.length ? cur2[Math.floor(cur2.length / 2)].p.p : 15000;
        st.min = Math.max(st.min || 0, med2 + 1); st.max = BIG; st.budgetId = null; st.premium = true;
        this.showResults('Huhú, jöhet a különlegesebb:'); break;
      case 'again': st.round++; this.showResults('Más szemmel nézve, íme pár új ötlet:'); break;
      case 'more': this.renderCards(this.allRes, this.shown + 8, true); break;
      case 'restart': this.reset(false); track('restart'); break;
      case 'add': this.addToCart(btn); break;
      case 'chat': this.openChat(); break;
    }
  };

  Finder.prototype.free = function (text) {
    var p = parseText(text, this.products);
    var st = this.st;
    st.query = text;
    if (p.recip) { st.recip = p.recip; st.skip.recip = true; }
    if (p.teen) { st.teen = true; st.skip.recip = true; }
    if (p.occ) st.occ = p.occ;
    if (p.max != null) { st.min = p.min || 0; st.max = p.max; st.budgetId = null; st.premium = p.min >= 18000; }
    p.interests.forEach(function (id) { if (st.interests.indexOf(id) < 0) st.interests.push(id); });
    st.terms = p.terms;
    st.skip.interest = true;
    track('free_text', { found: p.found });
    var bits = [];
    if (p.recip) { var R = byId(RECIPIENTS, p.recip); bits.push(R.emoji + ' ' + R.label.toLowerCase()); }
    if (p.teen) bits.push('🧑 tininek');
    if (p.occ) { var O = byId(OCCASIONS, p.occ); bits.push(O.emoji + ' ' + O.say); }
    if (p.max != null) bits.push(p.max >= BIG ? '✨ ' + fmtFt(p.min) + ' felett' : '💶 max ' + fmtFt(p.max));
    p.interests.slice(0, 2).forEach(function (id) { var it = byId(INTERESTS, id); bits.push(it.emoji + ' ' + it.label.toLowerCase()); });
    var lead = bits.length ? 'Értem! ' + bits.join(' · ') + ' – nézd, mit találtam:' : (p.terms.length ? 'Huhú, nézzük, mit találok erre:' : 'Hmm, ezt nem egészen értettem, de ezek tetszhetnek:');
    this.showResults(lead);
  };

  Finder.prototype.fromSearch = function () {
    var q = '';
    try { q = new URLSearchParams(window.location.search).get('q') || ''; } catch (e) { q = ''; }
    var native = parseInt(this.root.getAttribute('data-native-count') || '0', 10);
    if (!q) { this.root.hidden = true; return; }
    var p = parseText(q, this.products);
    var smart = (p.recip || p.occ || p.max != null || p.interests.length || p.teen) ? 1 : 0;
    if (!smart && native > 0) { this.root.hidden = true; return; }
    if (this.input) this.input.value = q;
    this.root.hidden = false;
    this.free(q);
  };

  Finder.prototype.showResults = function (lead) {
    var self = this, st = this.st;
    this.root.classList.add('is-done');
    this.renderPicked();
    var rk = rankWithFallback(this.products, st);
    var res = rk.list;
    this.allRes = res;
    var nodes = [];
    if (res.length) {
      nodes.push(this.chip('Olcsóbbat', '💸', 'cheaper'));
      nodes.push(this.chip('Különlegesebbet', '✨', 'fancier'));
      nodes.push(this.chip('Más ötleteket', '🔄', 'again'));
    }
    if (!st.recip && !st.teen && !st.interests.length) {
      RECIPIENTS.forEach(function (r) { nodes.push(self.chip(r.label, r.emoji, 'recip', r.id, 'uhu-chip--soft')); });
    } else if (!st.occ) {
      OCCASIONS.slice(0, 4).forEach(function (o) { nodes.push(self.chip(o.label, o.emoji, 'occ', o.id, 'uhu-chip--soft')); });
    }
    if (document.querySelector('shopify-chat, inbox-online-store-chat')) nodes.push(this.chip('Kérdezd Uhut chatben', '💬', 'chat', null, 'uhu-chip--soft'));
    nodes.push(this.chip('Újrakezdem', '↩️', 'restart', null, 'uhu-chip--ghost'));
    var msg = lead || (res.length ? 'Huhú! Ezeket ajánlom neked:' : 'Hmm, erre most nincs ötletem a polcon.');
    if (rk.note && res.length) msg = (lead ? lead + ' ' : '') + rk.note;
    track('results', { n: res.length });
    this.talk(msg, function () {
      self.setChips('', []);
      self.renderCards(res, 8, false);
      self.renderRefine(res.length ? 'Pontosítsunk?' : 'Próbáljuk másképp:', nodes);
      self.owl.mood('is-happy', 900);
      self.owl.mood('is-wave', 1900);
    });
  };

  Finder.prototype.renderRefine = function (label, nodes) {
    if (!this.results) return;
    var wrap = this.results.querySelector('.uhu-refine');
    if (!wrap) { wrap = el('div', 'uhu-refine'); this.results.appendChild(wrap); }
    wrap.innerHTML = '';
    wrap.appendChild(el('p', 'uhu__q', label));
    var box = el('div', 'uhu__chips');
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', label);
    nodes.forEach(function (n) { box.appendChild(n); });
    wrap.appendChild(box);
  };

  Finder.prototype.rotatePlaceholder = function () {
    var inp = this.input;
    if (!inp) return;
    var narrow = inp.clientWidth && inp.clientWidth < 300;
    var ex = narrow
      ? ['Pl. apának szülinapra', 'Pl. anyának, wellness', 'Pl. 8 éves kisfiúnak', 'Pl. Harry Potter fannak', 'Pl. férjemnek, 20e felett', 'Pl. kollégának 5e alatt']
      : [inp.getAttribute('placeholder'), 'Pl. anyának karácsonyra, wellness', 'Pl. 8 éves kisfiúnak logikai játék', 'Pl. Harry Potter rajongó tesómnak', 'Pl. barátnőmnek névnapra, 5 ezer alatt', 'Pl. férjemnek valami különleges'];
    inp.setAttribute('placeholder', ex[0]);
    if (reduceMotion()) return;
    var i = 0;
    setInterval(function () {
      if (document.activeElement === inp || inp.value || document.hidden) return;
      i = (i + 1) % ex.length;
      inp.setAttribute('placeholder', ex[i]);
    }, 3400);
  };

  Finder.prototype.renderCards = function (res, upto, append) {
    var box = this.results;
    if (!box) return;
    var self = this;
    if (!append) {
      box.innerHTML = '';
      this.shown = 0;
      this.grid = el('div', 'uhu-grid');
      this.grid.setAttribute('role', 'list');
      box.appendChild(this.grid);
      this.moreWrap = el('div', 'uhu-more');
      box.appendChild(this.moreWrap);
    }
    var end = Math.min(res.length, upto);
    for (var i = this.shown; i < end; i++) this.grid.appendChild(this.card(res[i]));
    this.shown = end;
    this.current = res.slice(0, end);
    this.moreWrap.innerHTML = '';
    if (res.length > end) {
      var mb = el('button', 'uhu-chip uhu-chip--soft', 'Mutass még (' + (res.length - end) + ')');
      mb.type = 'button'; mb.setAttribute('data-act', 'more');
      this.moreWrap.appendChild(mb);
    }
    if (!res.length) {
      var empty = el('p', 'uhu-empty', 'Írd le másképp, vagy nézd meg az összes ajándékot.');
      var a = el('a', 'uhu-link', 'Összes ajándék →'); a.href = '/collections/all';
      empty.appendChild(document.createTextNode(' ')); empty.appendChild(a);
      box.appendChild(empty);
    }
    box.hidden = false;
    if (!append) {
      var r = box.getBoundingClientRect();
      if (r.top > window.innerHeight * 0.8 || r.top < 0) {
        var anchor = (this.say && this.say.closest('.uhu__bubble')) || box;
        var y = window.pageYOffset + anchor.getBoundingClientRect().top - 84;
        try { window.scrollTo({ top: y, behavior: reduceMotion() ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, y); }
      }
    }
  };

  Finder.prototype.card = function (x) {
    var p = x.p;
    var c = el('article', 'uhu-card');
    c.setAttribute('role', 'listitem');
    var a = el('a', 'uhu-card__img'); a.href = p.u; a.setAttribute('tabindex', '-1'); a.setAttribute('aria-hidden', 'true');
    if (p.i) { var img = el('img'); img.src = p.i; img.alt = ''; img.loading = 'lazy'; img.width = 400; img.height = 400; a.appendChild(img); }
    c.appendChild(a);
    var body = el('div', 'uhu-card__body');
    var t = el('a', 'uhu-card__title', p.t); t.href = p.u;
    body.appendChild(t);
    if (x.why && x.why.length) body.appendChild(el('p', 'uhu-card__why', x.why.slice(0, 2).join(' · ')));
    var pr = el('p', 'uhu-card__price');
    pr.appendChild(el('span', 'uhu-card__now', fmtFt(p.p)));
    if (p.cp && p.cp > p.p) { var s = el('s', 'uhu-card__was', fmtFt(p.cp)); pr.appendChild(document.createTextNode(' ')); pr.appendChild(s); }
    body.appendChild(pr);
    var b = el('button', 'uhu-card__add button', 'Kosárba');
    b.type = 'button'; b.setAttribute('data-act', 'add'); b.setAttribute('data-val', String(p.v));
    b.setAttribute('aria-label', 'Kosárba: ' + p.t);
    body.appendChild(b);
    c.appendChild(body);
    return c;
  };

  Finder.prototype.addToCart = function (btn) {
    if (!btn || btn.disabled) return;
    var self = this;
    var id = parseInt(btn.getAttribute('data-val'), 10);
    var drawer = document.querySelector('cart-drawer');
    var cartNotif = document.querySelector('cart-notification');
    var sections = [];
    if (drawer && drawer.getSectionsToRender) sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
    else if (cartNotif && cartNotif.getSectionsToRender) sections = cartNotif.getSectionsToRender().map(function (s) { return s.id; });
    btn.disabled = true;
    var old = btn.textContent;
    btn.textContent = '…';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var payload = { id: id, quantity: 1 };
    if (sections.length) { payload.sections = sections.join(','); payload.sections_url = window.location.pathname; }
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status && res.status >= 400) throw new Error(res.description || 'hiba');
        btn.textContent = '✓ Kosárban';
        self.owl.mood('is-happy', 900);
        track('add_to_cart', { v: id });
        var target = drawer || cartNotif;
        if (target && target.renderContents && res.sections) {
          var inner = drawer && drawer.querySelector('.drawer__inner');
          if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          if (inner && inner.classList.contains('is-empty')) inner.classList.remove('is-empty');
          target.renderContents(res);
        } else {
          window.location.href = root + 'cart';
        }
        setTimeout(function () { btn.disabled = false; btn.textContent = old; }, 2500);
      })
      .catch(function () {
        btn.textContent = 'Hoppá, próbáld újra';
        setTimeout(function () { btn.disabled = false; btn.textContent = old; }, 2200);
      });
  };

  Finder.prototype.openChat = function () {
    var c = document.querySelector('shopify-chat, inbox-online-store-chat');
    try {
      var b = c && c.shadowRoot && c.shadowRoot.querySelector('button');
      if (b) { b.click(); return; }
    } catch (e) { /* */ }
    window.location.href = '/pages/kapcsolat';
  };

  function boot() {
    var roots = document.querySelectorAll('[data-uhu]:not([data-uhu-ready])');
    for (var i = 0; i < roots.length; i++) {
      roots[i].setAttribute('data-uhu-ready', '1');
      try { new Finder(roots[i]); } catch (e) { if (window.console) console.warn('Uhu', e); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);

  window.UhuFinder = { parse: function (t) { return parseText(t, []); } };
})();
